export enum QuickMessageTypeId {
  Recipients = 1,
  Staff = 2,
  Patient = 3,
}
